<template>
    <b-row>
        <b-col cols="9">
            <b-row>
                <b-col class="workspace-header">
                    <div>
                        <b-button size="lg" variant="primary" to="/inventory/returns/full"
                                  v-if="$route.params.status === 'returns'">
                            <i class="fa-regular fa-box-full"></i> Full Returns
                        </b-button>

                        <b-button size="lg" variant="primary"
                                  v-if="$route.params.status === 'returns'"
                                  class="mx-3"
                                  to="/inventory/returns/expedited">
                            <i class="fa-regular fa-shipping-fast"></i> Expedited Returns
                        </b-button>

                        <b-button size="lg" variant="primary"
                                  to="/inventory/returns/split-kit"
                                  v-if="$route.params.status === 'returns'">
                            <i class="fa-regular fa-columns"></i> Split Kit Returns
                        </b-button>
                    </div>
                </b-col>
                <b-col cols="5" class="workspace-header">
                    <h1 class="text-right"><i class="fa-duotone fa-boxes fa-fw"></i> Inventory Management</h1>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <transition appear name="fade" mode="out-in">
                        <router-view ref="listView" :status="$route.params.status"></router-view>
                    </transition>
                </b-col>
            </b-row>
        </b-col>







        <b-col cols="3">
            <b-row class="mb-4">
                <b-col>
                    <b-button active active-class="bg-primary" class="mb-4" block to="/inventory/returns/full">
                        <div class="text-center text-uppercase font-weight-bold font-xs text-white mb-1">Returns</div>
                        <b-list-group horizontal class="returns-side-widget" >
                            <b-list-group-item class="item p-1 text-center">
                                <div>Full</div>
                                <div class="font-weight-bold h4 mb-0">{{ dashboardData.dashboardReturnsFull }}</div>
                            </b-list-group-item>
                            <b-list-group-item class="item p-1 text-center">
                                <div>Expedited</div>
                                <div class="font-weight-bold h4 mb-0">{{ dashboardData.dashboardReturnsExpedited }}</div>
                            </b-list-group-item>
                            <b-list-group-item class="item p-1 text-center">
                                <div>Split Kit</div>
                                <div class="font-weight-bold h4 mb-0">{{ dashboardData.dashboardReturnsSplitKit }}</div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-button>

                    <dashboard-side-data-widget label="Returns of Returns" :data="dashboardData.dashboardReturnOfReturns"
                                                clickable icon="fa-light fa-share-all"
                                                to="/inventory/return-of-returns">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="2nd Returns of Returns" :data="dashboardData.dashboardSecondReturnOfReturns"
                                                clickable icon="fa-light fa-share-all"
                                                to="/inventory/second-return-of-returns">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Received Today" :data="dashboardData.dashboardReceivedToday"
                                                icon="fa-light fa-pallet-alt">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Offers Generated" :data="dashboardData.dashboardOffersGenerated"
                                                clickable icon="fa-light fa-box-circle-check"
                                                to="/inventory/offers-generated">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Active Outstanding Kits" :data="dashboardData.dashboardOutstandingKits"
                                                clickable icon="fa-light fa-box-open"
                                                to="/inventory/outstanding-kits/active">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Ongoing Outstanding Kits" :data="dashboardData.dashboardOngoingOutstandingKits"
                                                clickable icon="fa-light fa-box-open"
                                                to="/inventory/outstanding-kits/ongoing">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Paid Kits" :data="dashboardData.dashboardPaidKits"
                                                clickable icon="fa-light fa-money-bill-alt"
                                                to="/inventory/paid-kits">
                    </dashboard-side-data-widget>

                    <b-button @click="printLabels" block :disabled="printing">Print Order Labels</b-button>
                    <b-button @click="printLocationLabels" block :disabled="printing">Print Location Labels</b-button>

                </b-col>
            </b-row>

        </b-col>

    </b-row>
</template>

<script>
    import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
    import {BROADCAST_CONNECTED} from '@/store/actions';
    import {assign} from 'lodash';
    export default {
        name: 'inventory-index',
        title: 'Inventory',
        components: {DashboardSideDataWidget},
        data() {
            return {
                dashboardData: {
                    dashboardReturnsFull: null,
                    dashboardReturnsExpedited: null,
                    dashboardReturnsSplitKit: null,
                    dashboardReturnOfReturns: null,
                    dashboardSecondReturnOfReturns: null,
                    dashboardReceivedToday: null,
                    dashboardOffersGenerated: null,
                    dashboardOutstandingKits: null,
                    dashboardOngoingOutstandingKits: null,
                    dashboardPaidKits: null,
                },
                printing: false,
            };
        },
        beforeCreate() {
            this.$barcodeScanner.destroy();
        },
        created() {
            this.$qz.connect();
        },
        mounted() {
            this.getDashboardData();
            
            console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
            if (! this.$store.getters.isBroadcastConnected) {
                this.$store.subscribe((mutation) => {
                    console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                    if (mutation.type === BROADCAST_CONNECTED) {
                        console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                        this.joinBroadcastChannel();
                    }
                });
            } else {
                console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
                this.joinBroadcastChannel();
            }
        },
        beforeDestroy() {
            console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.InventoryManagement channel from Inventory/index.vue.');
            this.$echo.leaveChannel('App.InventoryManagement');
            this.$barcodeScanner.destroy();
        },
        methods: {
            joinBroadcastChannel: function () {
                console.info(String.fromCodePoint(0x1F91D) + ' Joining App.InventoryManagement channel from Inventory/index.vue.');
                this.$echo.channel('App.InventoryManagement')
                    .listen('BroadcastDashboardUpdate', (e) => {
                        this.dashboardData = assign(this.dashboardData, e.payload);
                    });
            },
            getDashboardData() {
                this.$http.get('/inventory_management/dashboard')
                    .then(response => {
                        this.dashboardData = response.data;
                    });
            },
            async printLabels() {
                this.printing = true;
                await _.forEach(this.$refs.listView.orders, async (order) => {
                let printData = '^XA\n' +
                    '^LH0,0\n' +
                    '^CF0,30,30\n' +
                    '^PW609\n' +
                    '~SD7\n' +
                    '\n' +
                    '^PON\n' +
                    '\n' +
                    '^FO20,20\n' +
                    '^AU\n' +
                    '^FB609,2,0,C\n' +
                    '^FDO#: ' + order.id + '^FS' +
                    '^FO120,80\n' +
                    '^BY3,3\n' +
                    '^B3N,N,120,N\n' +
                    '^FDO' + order.id + '^FS' +
                    '^PQ1\n' +
                    '^XZ';
                await this.$printer.printRaw('zebra', printData);
                });
                this.printing = false;
            },
            printLocationLabels() {
                _.forEach(this.$refs.listView.safe_options, (location) => {
                    let printData = '^XA\n' +
                        '^LH0,0\n' +
                        '^CF0,30,30\n' +
                        '^PW609\n' +
                        '~SD7\n' +
                        '\n' +
                        '^PON\n' +
                        '\n' +
                        '^FO20,20\n' +
                        '^AU\n' +
                        '^FB609,2,0,C\n' +
                        '^FD' + location.text + '^FS' +
                        '^FO120,80\n' +
                        '^BY3,3\n' +
                        '^B3N,N,120,N\n' +
                        '^FDSL' + location.value + '^FS' +
                        '^PQ1\n' +
                        '^XZ';
                    this.$printer.printRaw('zebra', printData);
                });
            }
        },
        watch: {
        },
    };
</script>

<style scoped>
    .returns-side-widget .item {
        width: 33.3%;
    }
</style>
